<ng-container *ngIf="!isLoading">

    <ng-container *ngIf="!isUserLoggedIn">
        <app-auth-login></app-auth-login>
    </ng-container>

    <ng-container *ngIf="isUserLoggedIn">
        <app-loading></app-loading>
        <app-navbar *ngIf="!bareLayout"></app-navbar>
        <app-breadcrumb *ngIf="!bareLayout"></app-breadcrumb>
        <router-outlet></router-outlet>
    </ng-container>

</ng-container>
